import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const AiUsageReportListContainer = React.lazy(
  () => import('../../containers/ai-usage-report-list/ai-usage-report-list.container')
);

const { LIST } = APP_ROUTES.AI_USAGE_REPORT_MODULE.CHILDREN as RouteConfig;
const listPath = LIST.FULL_PATH;

export const AiUsageReportRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={listPath} />
  },
  {
    path: listPath,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.HELP_DESK_SUPPORT]}
          component={AiUsageReportListContainer}
        />
      </React.Suspense>
    )
  }
];
